/* eslint react/jsx-filename-extension: 0 */
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom";

import portals from "./config/components";
import SuspenseFallback from "./components/SuspenseFallback/SuspenseFallback";

// Create a placeholder app
const app = document.createElement("DIV");
app.id = "app";
document.body.appendChild(app);

// Render portals app
ReactDOM.render(
  <div>
    {Object.keys(portals).map((type) =>
      Object.keys(portals[type])
        .map((selector) => {
          let elementExists = false;
          if (type === "id") {
            elementExists = document.getElementById(selector);
          } else if (type === "class") {
            elementExists =
              document.getElementsByClassName(selector).length > 0;
          }
          if (elementExists) {
            const Component = portals[type][selector];
            // eslint-disable-next-line react/no-array-index-key
            return (
              <SuspenseFallback key={`${type}-${selector}`}>
                <Component />
              </SuspenseFallback>
            );
          }
          return undefined;
        })
        .filter((el) => !!el)
    )}
  </div>,
  document.getElementById("app")
);
